import {
  AIAction,
  Direction,
  EnemyType,
  ItemType,
} from "../../../defines/enums"
import { CombatConfig, Position, RenderConfig } from "../../../defines/types"
import { Timer } from "../../../utils/timer"
import { BounceEnemy } from "./bounce"

export class BounceAsyncEnemy extends BounceEnemy {
  public static BASE_TIMER: number = 1000
  private _timer: Timer

  constructor(
    type: EnemyType,
    experience: number,
    combat: CombatConfig,
    position: Position,
    render: RenderConfig,
    name: string,
    direction?: Direction,
    optic?: ItemType
  ) {
    super(type, experience, combat, position, render, name, direction, optic)

    this._timer = new Timer(BounceAsyncEnemy.BASE_TIMER)
    this._timer.start(true, () => {
      this.checkState()
    })
  }

  checkState(): void {
    this._state = this.projectMove()

    if (this._state == AIAction.ATTACKING) {
      if (!this.isAlive()) {
        this._state = AIAction.DIED
        window.engine.removeEntityAtLocation(this.position)
        window.engine.requestUpdate()
      }
    }
  }

  stopTimer(): void {
    this._timer.stop()
  }
}
